import React, { useState, useEffect, useContext } from "react";
import api from "../../utils/Api";
import { AuthContext } from "../../context/AuthContext";

function AusenciasEmpleado() {
  const { token } = useContext(AuthContext);

  const [ausencias, setAusencias] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [generalError, setGeneralError] = useState("");
  const [notification, setNotification] = useState("");

  const [formData, setFormData] = useState({
    tipo: "vacaciones",
    fecha_inicio: "",
    fecha_fin: "",
    nota_trabajador: "",
    estado: "pendiente",
  });

  useEffect(() => {
    if (token) loadAusencias();
  }, [token]);

  // Carga segura de ausencias
  const loadAusencias = async () => {
    try {
      const res = await api.get("/ausencias/mias", {
        headers: { Authorization: `Bearer ${token}` },
      });

      console.log("Respuesta backend:", res.data);

      // Blindaje total contra formatos raros
      let data = res.data;

      if (Array.isArray(data)) {
        setAusencias(data);
      } else if (Array.isArray(data.ausencias)) {
        setAusencias(data.ausencias);
      } else if (Array.isArray(data.data)) {
        setAusencias(data.data);
      } else {
        setAusencias([]);
      }
    } catch (err) {
      console.error(err);
      setGeneralError("Error al cargar las ausencias.");
      setAusencias([]);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value,
    });
  };

  const enviarSolicitud = async () => {
    setGeneralError("");
    setNotification("");

    if (!formData.fecha_inicio || !formData.fecha_fin) {
      setGeneralError("Las fechas son obligatorias.");
      return;
    }

    if (formData.fecha_fin < formData.fecha_inicio) {
      setGeneralError("La fecha fin no puede ser menor que la de inicio.");
      return;
    }

    try {
      await api.post("/ausencias", formData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setNotification("Solicitud enviada correctamente.");
      setShowModal(false);

      setFormData({
        tipo: "vacaciones",
        fecha_inicio: "",
        fecha_fin: "",
        nota_trabajador: "",
        estado: "pendiente",
      });

      loadAusencias();
    } catch (err) {
      console.error(err);
      setGeneralError("Error al enviar la solicitud: " + (err.response?.data?.message || err.message));
    }
  };

  const getBadgeColor = (estado) => {
    switch (estado) {
      case "aprobada":
        return "bg-success";
      case "pendiente":
        return "bg-warning text-dark";
      case "rechazada":
        return "bg-danger";
      default:
        return "bg-secondary";
    }
  };

  return (
    <div className="container my-4">
      <h1 className="fs-3 fw-bold mb-4">Mis ausencias</h1>

      {notification && (
        <div className="alert alert-success">{notification}</div>
      )}

      {generalError && (
        <div className="alert alert-danger">{generalError}</div>
      )}

      <div className="mb-3">
        <button
          className="btn"
          style={{ background: "rgb(255, 122, 0)", color: "white" }}
          onClick={() => setShowModal(true)}
        >
          Solicitar nueva ausencia
        </button>
      </div>

      {/* Tabla protegida */}
      {Array.isArray(ausencias) && ausencias.length === 0 ? (
        <p className="text-center mt-5">
          No tienes ausencias registradas.
        </p>
      ) : (
        <table className="table table-striped shadow-sm">
          <thead>
            <tr>
              <th>Tipo</th>
              <th>Fecha inicio</th>
              <th>Fecha fin</th>
              <th>Nota</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(ausencias) &&
              ausencias.map((a) => (
                <tr key={a.id}>
                  <td>{a.tipo}</td>
                  <td>
                    {new Date(a.fecha_inicio).toLocaleDateString()}
                  </td>
                  <td>
                    {new Date(a.fecha_fin).toLocaleDateString()}
                  </td>
                  <td>{a.nota_trabajador}</td>
                  <td>
                    <span className={`badge ${getBadgeColor(a.estado)}`}>
                      {a.estado}
                    </span>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      )}

      {/*  Modal React */}
      {showModal && (
        <div
          className="modal d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content shadow">
              <div className="modal-header">
                <h5 className="modal-title">
                  Solicitar nueva ausencia
                </h5>
                <button
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>

              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">
                    Tipo de ausencia
                  </label>
                  <select
                    className="form-select"
                    id="tipo"
                    value={formData.tipo}
                    onChange={handleChange}
                  >
                    <option value="vacaciones">
                      Vacaciones
                    </option>
                    <option value="enfermedad">
                      Enfermedad
                    </option>
                    <option value="personal">
                      Personal
                    </option>
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Fecha de inicio
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id="fecha_inicio"
                    value={formData.fecha_inicio}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Fecha de fin
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id="fecha_fin"
                    value={formData.fecha_fin}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Nota</label>
                  <textarea
                    className="form-control"
                    id="nota_trabajador"
                    rows="3"
                    value={formData.nota_trabajador}
                    onChange={handleChange}
                  ></textarea>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancelar
                </button>
                <button
                  className="btn"
                  style={{
                    background: "rgb(255, 122, 0)",
                    color: "white",
                  }}
                  onClick={enviarSolicitud}
                >
                  Enviar solicitud
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AusenciasEmpleado;